import { MutationTree } from 'vuex';
import { RootMutations, RootState, User } from '@/store/types';

export const mutations: MutationTree<RootState> = {
  [RootMutations.SET_USER](state, user: User) {
    state.user = user;
  },
  [RootMutations.REMOVE_USER](state) {
    state.user = null;
  }
};
